export enum TabEnum {
    CareerTab = 1,
    PeopleTab = 2,
    SkillTab = 3,
    DashboardTab = 4
}